import { useContext, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Menu from './Menu'
import { Typography } from '@mui/material'
import { FactCheck, HealthAndSafety, Stream, ChevronLeftSharp, AllInclusive } from '@mui/icons-material'
import MenuItem from './MenuItem'
import RoleContext from '../auth/RoleContext'
import UserContext from '../auth/UserContext'
import { getForumEmbedConfig } from '../communityHub/utils'
import { COMMUNITY_HUB_GROUP_IDS } from '../communityHub/access'
import { getSiteConfig } from '../community/siteProvider'
import MenuDivider from './MenuDivider'

export default function SidebarCommunityMenu(props = {}) {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const location = useLocation()
  const roleDetails = useContext(RoleContext)
  const userDetails = useContext(UserContext)

  const [vivaCommunityLinkPrefix, setVivaCommunityLinkPrefix] = useState(null)
  
  const { isBottlerUser, isInternalUser, isSiteManager} = roleDetails

  useEffect(() => {
    const { vivaCommunity } = getSiteConfig('safety-community-hub')
    if (vivaCommunity) setVivaCommunityLinkPrefix(vivaCommunity['communityLinkPrefix'])
  }, [])

  const animationSpeed = 200

  const isExpandedLocation = (pathRegex, flags = undefined) => {
    const t = new RegExp(pathRegex, flags)
    const match = t.test(location.pathname)
    return match
  }
  const safetyForumEmbedConfig = getForumEmbedConfig()

  const getQualityLibraryMenu = () => {
    const subMenus = []
    for (const d of getSiteConfig('quality-hub').libraryDrives) {
      if (d.route) {
        const m = <MenuItem key={d.route} activePaths={[`/quality-hub/resource-library/${d.route}`]} href={`/quality-hub/resource-library/${d.route}`} title={<Typography fontWeight='400' variant='body2'>{d.label}</Typography>} />
        subMenus.push(m)
      }
    }
    // getSiteConfig('quality-hub').libraryDrives.reduce((p, d) => {
    //               if (d.route) {
    //                 const m = <MenuItem key={d.route} activePaths={[`/quality-hub/resource-library/${d.route}`]} href={`/quality-hub/resource-library/${d.route}`} title={<Typography fontWeight='400' variant='body2'>{d.label}</Typography>} />
    //                 return [...p, m]
    //               }  
    //             return p},[])
    const libraryMenu = (
      <MenuItem activePaths={['/quality-hub/resource-library']} href='/quality-hub/resource-library/quality-food-safety' animationSpeed={animationSpeed} expanded={isExpandedLocation('/quality-hub/resource-library/.*')} title={<Typography fontWeight='400' variant='body2'>Resource Library</Typography>} theme='treeview-menu-static'>
        { subMenus }
      </MenuItem>)
    return libraryMenu
  }

  return (
    <Menu>
      <MenuItem id='main-menu' href='/' title="Back to Home" icon={<ChevronLeftSharp />} />

      {(userDetails.hasGroupIdMembership(COMMUNITY_HUB_GROUP_IDS) || roleDetails.isAdminUser())
        && 
        (isInternalUser() || isBottlerUser())
        &&
        <>
        <MenuItem id='community-hub-menu' activePaths={['/qse-community-hub']} href='/qse-community-hub' title="QSE Community Hub" icon={<Stream />} />
        <MenuDivider />

        <MenuItem id='quality-hub-menu' href='/quality-hub/news' expanded={true} activePaths={[/\/quality-hub*./]} title="Quality" icon={<FactCheck />} theme='treeview-menu-static' key='quality'>
          <MenuItem activePaths={['/quality-hub/news']} href={`/quality-hub/news`} title={<Typography fontWeight='400' variant='body2'>Quality News</Typography>} />
          <MenuItem activePaths={['/quality-hub/ou-corner']} href={`/quality-hub/ou-corner`} title={<Typography fontWeight='400' variant='body2'>OU Corner</Typography>} />
          { getQualityLibraryMenu() }
          {isSiteManager('quality-hub') && <MenuItem activePaths={['/quality-hub/settings']} href={`/quality-hub/settings`} title={<Typography fontWeight='400' variant='body2'>Settings</Typography>} />}
        </MenuItem>

        <MenuItem id='safety-hub-menu' href='/safety-community-hub/news' animationSpeed={animationSpeed} expanded={true /*isExpandedLocation('/safety-community-hub*./')*/} activePaths={[/\/safety-community-hub*./]} title="Safety" icon={<HealthAndSafety />} theme='treeview-menu-static' key='safety'>
          <MenuItem activePaths={['/safety-community-hub/news']} href={`/safety-community-hub/news`} title={<Typography fontWeight='400' variant='body2'>Safety News</Typography>} />
          <MenuItem activePaths={['/safety-community-hub/ou-corner']} href={`/safety-community-hub/ou-corner`} title={<Typography fontWeight='400' variant='body2'>Safety OU Corner</Typography>} />
          <MenuItem activePaths={['/safety-community-hub/resource-library']} href={`/safety-community-hub/resource-library`} title={<Typography fontWeight='400' variant='body2'>Resource Library</Typography>} />
          {(safetyForumEmbedConfig.embedUrl) && <>
            { isBottlerUser() && 
              <MenuItem toBlank={true} href={`${vivaCommunityLinkPrefix}${safetyForumEmbedConfig.communityId}`} title={<Typography fontWeight='400' variant='body2'>Community Forum</Typography>} />
            }
            { isInternalUser() &&
              <MenuItem activePaths={['/safety-community-hub/forum']} href={`/safety-community-hub/forum`} title={<Typography fontWeight='400' variant='body2'>Community Forum</Typography>} />
            }
            </>
          }
          {isSiteManager('safety-community-hub') && <MenuItem activePaths={['/safety-community-hub/settings']} href={`/safety-community-hub/settings`} title={<Typography fontWeight='400' variant='body2'>Settings</Typography>} />}
        </MenuItem>
        
        <MenuItem id='sustainability-hub-menu' href='/sustainability-hub/news' animationSpeed={animationSpeed} expanded={true /*isExpandedLocation('/sustainability-hub*./')*/} activePaths={[/\/sustainability-hub*./]} title="Sustainability" icon={<AllInclusive />} theme='treeview-menu-static' key='sustainability'>
          <MenuItem activePaths={['/sustainability-hub/news']} href={`/sustainability-hub/news`} title={<Typography fontWeight='400' variant='body2'>Sustainability News</Typography>} />
          <MenuItem activePaths={['/sustainability-hub/ou-corner']} href={`/sustainability-hub/ou-corner`} title={<Typography fontWeight='400' variant='body2'>OU Corner</Typography>} />
          <MenuItem activePaths={['/sustainability-hub/resource-library']} href={`/sustainability-hub/resource-library`} title={<Typography fontWeight='400' variant='body2'>Resource Library</Typography>} />
          {isSiteManager('sustainability-hub') && <MenuItem activePaths={['/sustainability-hub/settings']} href={`/sustainability-hub/settings`} title={<Typography fontWeight='400' variant='body2'>Settings</Typography>} />}
        </MenuItem>
      </>
    }
    </Menu>
  )
}
